import { Collapse, Row, Col } from 'antd';
import React from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import Title from 'components/Title';
import { TpAuthorizationResponse } from 'services/thirdParty';
import { toCurrency } from 'utils/utils';
import FormInput from 'components/FormInput';
import SaveButton from 'components/SaveButton';

const { Panel } = Collapse;

export type PlafondsSFSProps = {
  id: number;
  tpauthlist: TpAuthorizationResponse[];
};

const PlafondsSFS = ({ id, tpauthlist }: PlafondsSFSProps) => {
  let tpAuthList = tpauthlist?.filter((tp) => tp.authstatus === 'ACTIVE');

  let tpAuthDetails = tpAuthList?.flatMap((tp) => tp.authDetail);

  return (
    <>
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined
            style={{ fontSize: 24, float: 'left' }}
            rotate={isActive ? 90 : 0}
          />
        )}
        expandIconPosition="start"
        defaultActiveKey={['1']}
      >
        {tpAuthDetails?.map((auth, index) => {

          return (
            <Panel
              header={<Title level={5} comcode={auth.offerlabel}></Title>}
              key={auth.authdetailid}
              style={{
                marginBottom: 24,
                //   overflow: 'hidden',
                background: '#f7f7f7',
                border: 10,
                borderRadius: 2,
                boxShadow:
                  'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
              }}
            >
              <Row gutter={16}>
                <Col span={4}>
                  <Row>
                    <Col xs={24}>
                      <FormInput name="Produits SVN" initialValue="OUI" />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={24}>
                      <FormInput name="Produit X" initialValue="NON" />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={24}>
                      <FormInput name="Produit Y" initialValue="NON" />
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row
                    gutter={80}
                    style={{marginLeft: '5%' }}
                  >
                    <Col xs={12}>
                      <FormInput
                        name="authdetailamount"
                        initialValue={toCurrency(
                          auth.authdetailamount,
                          auth.currcode ?? localStorage.getItem('currcode')
                        )}
                      />
                    </Col>
                    <Col xs={12}></Col>
                  </Row>
                </Col>
              </Row>
            </Panel>
          );
        })}
      </Collapse>
      <Row gutter={12} justify="center">
        <Col span={!Number(id) ? 5 : 4}>
          <SaveButton
            comcode="Annuler"
            custom={{ height: 45 }}
            onClick={() => {}}
          />
        </Col>
        <Col span={!Number(id) ? 5 : 4}>
          <SaveButton
            comcode="Enregistrer"
            custom={{ height: 45 }}
            onClick={() => {}}
          />
        </Col>
      </Row>
    </>
  );
};

export default PlafondsSFS;
